module.exports = __webpack_public_path__ + "static/img/otLogojm.2421ab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/otLogojm.png
// module id = dO7F
// module chunks = 44